import { render } from "./IconChecked.vue?vue&type=template&id=88b5a7c6"
import script from "./IconChecked.vue?vue&type=script&lang=js"
export * from "./IconChecked.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__